export default function AIPanel({ title, children }) {
  return (
    <div className="bg-gradient-to-br from-purple-950 to-purple-900 border border-purple-700 rounded-lg p-6">
      {/* Header with pulsing dot */}
      <div className="flex items-center gap-3 mb-4">
        <div className="relative w-3 h-3">
          <div className="absolute inset-0 bg-purple-400 rounded-full animate-pulse" />
          <div className="absolute inset-0 bg-purple-300 rounded-full" />
        </div>
        <h3 className="font-semibold text-purple-100">{title}</h3>
      </div>

      {/* Content */}
      <div className="text-gray-100">{children}</div>
    </div>
  );
}
